/**
 * "lat, lng" as typed or pasted from Google Maps ("-6.4268287, 106.7315315"). A pair in lng, lat
 * order is recognised when the first number cannot be a latitude.
 */
export function parseLatLng(text: string): { lat: number; lng: number } | null {
  const nums = text
    .trim()
    .split(/[\s,;]+/)
    .filter(Boolean)
    .map(Number);
  if (nums.length !== 2 || nums.some((n) => !Number.isFinite(n))) return null;
  let [lat, lng] = nums as [number, number];
  if (Math.abs(lat) > 90 && Math.abs(lng) <= 90) [lat, lng] = [lng, lat];
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  return { lat, lng };
}
